// extracted by mini-css-extract-plugin
export default {"container":"NoInternetConnection_container__JUw91"};